/**
 * Soluzione avanzata per nascondere i controlli di quantità dei bundle nel mini-carrello
 * Versione 2.0
 */
document.addEventListener('DOMContentLoaded', function() {
  // Configurazione
  const bundleIdentifiers = ['bundle', 'pacchetto', 'kit']; // Aggiungi altre parole chiave se necessario
  const miniCartSelectors = [
    'cart-drawer', 'cart-notification', '.cart__drawer', 
    '.mini-cart', '.cart-drawer', '#cart-drawer', 
    '.drawer__cart', '[data-cart-drawer]', '[data-section-id*="cart"]'
  ];
  
  // Funzione per verificare se un item è un bundle
  function isBundle(item) {
    // Cerca in diversi elementi che potrebbero contenere il titolo del prodotto
    const titleElements = item.querySelectorAll('a, h3, h4, .cart-item__name, .cart__item-title, [class*="title"], [class*="name"]');
    
    // Controlla se qualsiasi elemento titolo contiene una delle parole chiave bundle
    return Array.from(titleElements).some(element => {
      const text = element.textContent.toLowerCase();
      return bundleIdentifiers.some(keyword => text.includes(keyword));
    });
  }
  
  // Funzione principale per nascondere i controlli di quantità
  function hideQuantityForBundles() {
    console.log('Cercando elementi bundle nel carrello...'); // Log per debugging
    
    // Cerca il mini-carrello usando tutti i possibili selettori
    let miniCart = null;
    for (const selector of miniCartSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        miniCart = element;
        console.log('Mini-carrello trovato:', selector);
        break;
      }
    }
    
    if (!miniCart) {
      console.log('Mini-carrello non trovato');
      return;
    }
    
    // Cerca gli elementi del carrello - utilizziamo selettori più generici
    const cartItems = miniCart.querySelectorAll('li, [class*="item"], [class*="product"], [data-cart-item]');
    console.log(`Trovati ${cartItems.length} elementi nel carrello`);
    
    cartItems.forEach((item, index) => {
      if (isBundle(item)) {
        console.log(`Bundle trovato all'indice ${index}`);
        
        // Primo tentativo: cerca controlli di quantità standard
        const quantityControls = item.querySelectorAll(
          '.quantity-selector, .cart-item__quantity, ' +
          '[class*="quantity"], input[type="number"], ' +
          'button[class*="increment"], button[class*="decrement"], ' +
          'button[aria-label*="aumenta"], button[aria-label*="diminuisci"]'
        );
        
        // Secondo tentativo: cerca contenitori generici attorno ai controlli di quantità
        if (quantityControls.length === 0) {
          const qtyContainer = item.querySelector(
            '.quantity-container, [class*="quantity"], ' +
            '[class*="qty"], [data-quantity-wrapper]'
          );
          
          if (qtyContainer) {
            qtyContainer.style.display = 'none';
            console.log('Nascosto contenitore di quantità');
          }
        } else {
          // Nascondi tutti i controlli di quantità trovati
          quantityControls.forEach(control => {
            control.style.display = 'none';
            console.log('Nascosto controllo quantità:', control.className || control.tagName);
          });
        }
        
        // Aggiungi un indicatore che questo item è stato elaborato
        item.setAttribute('data-bundle-processed', 'true');
      }
    });
  }
  
  // Configura un MutationObserver per rilevare modifiche al DOM che potrebbero indicare
  // che il mini-carrello è stato aggiornato o aperto
  const bodyObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        // Verifica se uno degli elementi aggiunti o modificati potrebbe essere il mini-carrello
        const cartElements = document.querySelectorAll(miniCartSelectors.join(', '));
        if (cartElements.length > 0) {
          hideQuantityForBundles();
        }
      }
    }
  });
  
  // Osserva le modifiche al body
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-hidden']
  });
  
  // Gestisci i clic che potrebbero aprire il carrello
  document.addEventListener('click', function(e) {
    if (e.target.closest('[aria-label*="cart"], [aria-label*="carrello"], [class*="cart"], [data-cart-toggle]')) {
      console.log('Clic su elemento carrello rilevato');
      setTimeout(hideQuantityForBundles, 300);
      setTimeout(hideQuantityForBundles, 700);  // Riprova dopo un po' di tempo
    }
  });
  
  // Esegui la funzione all'avvio
  setTimeout(hideQuantityForBundles, 500);
  setTimeout(hideQuantityForBundles, 1500);  // Riprova dopo un po' di tempo
  
  // Inoltre, aggancia agli eventi AJAX di Shopify (se disponibili)
  if (typeof Shopify !== 'undefined' && Shopify.onCartUpdate) {
    const originalOnCartUpdate = Shopify.onCartUpdate;
    Shopify.onCartUpdate = function() {
      originalOnCartUpdate.apply(this, arguments);
      setTimeout(hideQuantityForBundles, 300);
    };
  }
  
  // Ascolta anche eventi di aggiornamento del carrello personalizzati
  document.addEventListener('cart:updated', hideQuantityForBundles);
  document.addEventListener('cart:refresh', hideQuantityForBundles);
  document.addEventListener('cart:build', hideQuantityForBundles);
});